import React from 'react'
import { ButtonPrimary } from 'components/Common/Buttons'
import useLanguageHooks from 'hooks/useLanguageHooks'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import RollbarConfig from 'utils/RollbarConfig'
import Constant from 'utils/Constants'
import useAuthRepo from 'services/repo/useAuthRepo'
import useCookieHook from 'hooks/useCookieHook'
import useAccessPermissionHook from 'hooks/useAccessPermissionHook'
import useCurrentProfileFromTokenHooks from 'hooks/useCurrentProfileFromTokenHooks'
import LocalStorageUtils from 'utils/LocalStorage'

export default function ClientError() {
	
	let error = useRouteError()
	const {t} = useLanguageHooks()
	const { logout } = useAuthRepo()
	const { removeAuthCookie } = useCookieHook()
	const { clearPermissionList } = useAccessPermissionHook()
	const { resetAllState } = useCurrentProfileFromTokenHooks(false)

	// Don't show error if user is logging out
	const isLoggingOut = sessionStorage.getItem('isLoggingOut') === 'true'
	
	if (isLoggingOut) {
		// Clear the flag and return null to prevent flash
		sessionStorage.removeItem('isLoggingOut')
		return null
	}

	RollbarConfig.error('Error Boundary', {
		'log': error, 
	})

	const handleGoToLogin = async () => {
		// Set flag to prevent error boundary flash during logout
		sessionStorage.setItem('isLoggingOut', 'true')
		
		// Attempt to logout (call API if possible)
		try {
			await logout()
		} catch (e) {
			// Logout API might fail, but we still want to clear local data
		}
		
		// Clear all local data
		removeAuthCookie()
		resetAllState()
		clearPermissionList()
		LocalStorageUtils.jwtToken.clear()
		LocalStorageUtils.language.clear()
		LocalStorageUtils.pdfViewer.clear()
		
		// Redirect to login
		window.location.replace('/')
	}

	let message = error + ''
	if(!isRouteErrorResponse(error) && message?.toLocaleLowerCase()?.indexOf('chunkloaderror')>=0) {
		return (
			<div className='luna-client-error-page'>
				<div className='error-body'>
					<img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
					<h2>{t('globalAlert.pageErrorOccuredTitle')}</h2>
					<p>{t('globalAlert.failedLoadChunk')}</p>
		
					<ButtonPrimary onClick={()=>window.location.reload(true) }>{t('common.reload')}</ButtonPrimary>
				</div>
			</div>
		)
	}

	if(error?.status === 404) {
		return (
			<div className='luna-client-error-page'>
				<div className='error-body'>
					<img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
					<h2>{t('globalAlert.notFound')}</h2>
					<p>{t('globalAlert.notFoundMessage')}</p>
		
					<ButtonPrimary onClick={handleGoToLogin}>{t('common.gotoLogin')}</ButtonPrimary>
				</div>
			</div>
		)
	}

	return (
		<div className='luna-client-error-page'>
			<div className='error-body'>
				<img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
				<h2>{t('globalAlert.pageErrorOccuredTitle')}</h2>
				<p>{t('globalAlert.pageErrorOccuredMsg')}</p>

				<ButtonPrimary onClick={handleGoToLogin}>{t('common.gotoLogin')}</ButtonPrimary>
			</div>
		</div>
	)
}
